export default __webpack_public_path__ + "static/media/iconMapbox.c166282f.png";